import { render } from "./UploadedImagePreview.vue?vue&type=template&id=64ba1df8&scoped=true&lang=pug"
import script from "./UploadedImagePreview.vue?vue&type=script&lang=js"
export * from "./UploadedImagePreview.vue?vue&type=script&lang=js"

import "./UploadedImagePreview.vue?vue&type=style&index=0&id=64ba1df8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ba1df8"]])

export default __exports__